(ns bec-cljs-common.components.scroll-container
  (:require [reagent.core :as r]
            [cljs.pprint]))

(defonce variables (atom {}))

(defn- components-changed? [components old-components & keys-to-compare]
  ;; In testing this doesn't seem to make it faster or slower.
  (if (not (= (count components) (count old-components)))
    true
    (not
      (empty?
        (for [index (range 2 (count components))
              :let [component (nth components index)
                    component-style-props (:style (second component))
                    old-component (nth old-components index)
                    old-component-style-props (:style (second old-component))]
              :when (not (= (select-keys component-style-props keys-to-compare)
                           (select-keys old-component-style-props keys-to-compare)))]
          component)))))

(defn main
  "The threshold is a value between 0 and 1. It describes from the top of an element how much that element needs to be
  visible before :on-cross-threshold is triggered. A threshold of 0.25 means that 25% of the element will be visible
  before we cross the threshold.

  Each child component must have an id and make sure that generated components in a sequence is returned as vector
  components and not as sequences.  If you return a sequence of components then the component will crash because the
  element id will be nil."
  [props]
  (let [scroll-id (or (:id props) "no-id")]
    (r/create-class
      {:component-did-mount
       (fn [this]
         (swap! variables
           (fn [a]
             (-> (assoc a scroll-id nil)
               (assoc-in [scroll-id :data] (:data props))
               (assoc-in [scroll-id :on-cross-threshold] (:on-cross-threshold props))
               (assoc-in [scroll-id :on-visible] (:on-visible props))
               (assoc-in [scroll-id :elements] []))))
         (let [on-cross-threshold (:on-cross-threshold (get @variables scroll-id))
               on-scrolling (:on-scrolling props)
               threshold (if (:threshold props)
                           (cond
                             (> (:threshold props) 1) 0
                             (< (:threshold props) 0) 1
                             :else (- 1 (:threshold props)))
                           0.5)
               scroll-direction (:scroll-direction props)
               components (remove nil? (js->clj (.-argv (.-props this))))]
           (swap! variables assoc-in [scroll-id :number-of-components] (count components))
           (doseq [index (range 2 (count components))
                   :let [component (nth components index)
                         component-props (second component)
                         component-children (nth component 2 nil)
                         element (js/document.getElementById (:id component-props))
                         element-width (when (= scroll-direction :horizontal)
                                         (try
                                           (.-width (.getBoundingClientRect element))
                                           (catch js/Error e
                                             (do
                                               (println (.-message e))
                                               0))))
                         element-height (when (not (= scroll-direction :horizontal))
                                          (try
                                            (.-height (.getBoundingClientRect element))
                                            (catch js/Error e
                                              (do
                                                (println (.-message e))
                                                0))))]
                   :when (and (not (or (= (:position (:style component-props)) "absolute")
                                     (= (:position (:style component-props)) "fixed")))
                           (not (= (or element-height element-width) 0)))]
             (swap! variables
               (fn [a]
                 (let [elements (get-in a [scroll-id :elements])]
                   (assoc-in a [scroll-id :elements]
                     (conj elements
                       (merge
                         (if (= scroll-direction :horizontal)
                           {:width element-width
                            :left-position (+ (:left-position (last elements)) (:width (last elements)))}
                           {:height element-height
                            :top-position (+ (:top-position (last elements)) (:height (last elements)))})
                         {:component-children component-children
                          :component-index (- index 2)
                          :index (if (:index (last elements))
                                   (inc (:index (last elements)))
                                   0)
                          :id (:id component-props)})))))))
           (.addEventListener (js/document.getElementById scroll-id) "scroll"
             (fn [event]
               (let [threshold-index (:threshold-index (get @variables scroll-id))
                     elements (:elements (get @variables scroll-id))
                     scroll-position (if (= scroll-direction :horizontal)
                                       event.currentTarget.scrollLeft
                                       event.currentTarget.scrollTop)]
                 (when (fn? on-scrolling)
                   (on-scrolling (merge
                                   (if (= scroll-direction :horizontal)
                                     {:scroll-width event.currentTarget.scrollWidth}
                                     {:scroll-height event.currentTarget.scrollHeight})
                                   {:scroll-position scroll-position})))
                 (doseq [element elements
                         :let [element-dimension (if (= scroll-direction :horizontal)
                                                   (:width element)
                                                   (:height element))
                               element-position (if (= scroll-direction :horizontal)
                                                  (:left-position element)
                                                  (:top-position element))
                               scroll-threshold-position (+ scroll-position (* element-dimension threshold))
                               element-bottom-position (+ element-dimension element-position)]
                         :when (and (not (= threshold-index (:index element)))
                                 (> scroll-threshold-position element-position)
                                 (<= scroll-threshold-position element-bottom-position))]
                   (swap! variables
                     #(-> (assoc-in % [scroll-id :threshold-index] (:index element))
                        (assoc-in [scroll-id :scroll-threshold-position] scroll-threshold-position)))
                   (when (fn? on-cross-threshold)
                     (on-cross-threshold {:first-adjacent-element (nth elements (dec (:index element)) nil)
                                          :current-element element
                                          :second-adjacent-element (nth elements (inc (:index element)) nil)
                                          :data (:data (get @variables scroll-id))
                                          :scroll-threshold-position scroll-threshold-position}))))))
           (if-let [scroll-position (:scroll-threshold-position (get @variables scroll-id))]
             (let [x-scroll-position (if (= scroll-direction :horizontal)
                                       scroll-position 0)
                   y-scroll-position (if (= scroll-direction :horizontal)
                                       0 scroll-position)]
               (.scrollTo (js/document.getElementById scroll-id) x-scroll-position y-scroll-position))
             (let [elements (:elements (get @variables scroll-id))
                   element (cond
                             (:initial-visible-element-id props)
                             (first (filter #(= (:id %) (:initial-visible-element-id props)) elements))
                             (number? (:initial-visible-element-index props))
                             (nth elements (:initial-visible-element-index props) nil)
                             :else
                             (first elements))
                   scroll-direction (:scroll-direction props)
                   x-scroll-position (if (= scroll-direction :horizontal)
                                       (+ (:left-position element) (* (:width element) 0.1)) 0)
                   y-scroll-position (if (= scroll-direction :horizontal)
                                       0 (+ (:top-position element) (* (:height element) 0.1)))]
               (if (= (:index element) 0)
                 (do
                   (swap! variables
                     #(-> (assoc-in % [scroll-id :threshold-index] 0)
                        (assoc-in [scroll-id :scroll-threshold-position] (if (= scroll-direction :horizontal)
                                                                           (* (:width element) 0.5)
                                                                           (* (:height element) 0.5)))))
                   (when (fn? on-cross-threshold)
                     (on-cross-threshold {:current-element element
                                          :second-adjacent-element (second elements)
                                          :data (:data (get @variables scroll-id))
                                          :scroll-threshold-position (if (= scroll-direction :horizontal)
                                                                       (* (:width element) 0.5)
                                                                       (* (:height element) 0.5))}))
                   (if (= scroll-direction :horizontal)
                     (set! (.-scrollLeft (js/document.getElementById scroll-id)) 0)
                     (set! (.-scrollTop (js/document.getElementById scroll-id)) 0)))
                 (.scrollTo (js/document.getElementById scroll-id) x-scroll-position y-scroll-position))))))
       :component-will-unmount
       (fn [this]
         (swap! variables assoc scroll-id nil)
         (.removeEventListener (js/document.getElementById scroll-id) "scroll" (fn [] nil)))
       :component-did-update
       (fn [this old-argv]
         (let [components (remove nil? (js->clj (.-argv (.-props this))))
               old-components (js->clj old-argv)
               props (second components)
               scroll-direction (:scroll-direction props)
               components-changed? (if (:only-check-component-count? props)
                                     (not (= (:number-of-components (get @variables scroll-id))
                                            (count components)))
                                     (components-changed? components old-components
                                       :width :min-width :max-width :height :min-height :max-height
                                       :padding :padding-right :padding-left :padding-top :padding-bottom
                                       :margin :margin-right :margin-left :margin-top :margin-bottom
                                       :border :border-right :border-left :border-top :border-bottom
                                       :display :position))]
           (swap! variables
             #(-> (assoc-in % [scroll-id :data] (:data props))
                (assoc-in [scroll-id :on-cross-threshold] (:on-cross-threshold props))
                (assoc-in [scroll-id :on-visible] (:on-visible props))))
           (when (or (not (:initial-element-scrolled-to? (get @variables scroll-id)))
                   components-changed?)
             (swap! variables assoc-in [scroll-id :elements] [])
             (doseq [index (range 2 (count components))
                     :let [component (nth components index)
                           component-props (second component)
                           component-children (nth component 2 nil)
                           element (js/document.getElementById (:id component-props))
                           element-width (when (= scroll-direction :horizontal)
                                           (try
                                             (.-width (.getBoundingClientRect element))
                                             (catch js/Error e
                                               (do
                                                 (cljs.pprint/pprint (.-message e))
                                                 0))))
                           element-height (when (not (= scroll-direction :horizontal))
                                            (try
                                              (.-height (.getBoundingClientRect element))
                                              (catch js/Error e
                                                (do
                                                  (cljs.pprint/pprint (.-message e))
                                                  0))))]
                     :when (and (not (or (= (:position (:style component-props)) "absolute")
                                       (= (:position (:style component-props)) "fixed")))
                             (not (= (or element-height element-width) 0)))]
               (swap! variables
                 (fn [a]
                   (let [elements (get-in a [scroll-id :elements])]
                     (assoc-in a [scroll-id :elements]
                       (conj elements
                         (merge
                           (if (= scroll-direction :horizontal)
                             {:width element-width
                              :left-position (+ (:left-position (last elements)) (:width (last elements)))}
                             {:height element-height
                              :top-position (+ (:top-position (last elements)) (:height (last elements)))})
                           {:component-children component-children
                            :component-index (- index 2)
                            :index (if (:index (last elements))
                                     (inc (:index (last elements)))
                                     0)
                            :id (:id component-props)}))))))))
           (swap! variables assoc-in [scroll-id :number-of-components] (count components))
           (when (or (not (= (:initial-visible-element-index (second old-components))
                            (:initial-visible-element-index props)))
                   (not (= (:initial-visible-element-id (second old-components))
                          (:initial-visible-element-id props))))
             (swap! variables assoc-in [scroll-id :initial-element-scrolled-to?] false))
           (if (:is-visible? props)
             (when-not (:initial-element-scrolled-to? (get @variables scroll-id))
               (let [elements (:elements (get @variables scroll-id))
                     element (cond
                               (:initial-visible-element-id props)
                               (first (filter #(= (:id %) (:initial-visible-element-id props)) elements))
                               (number? (:initial-visible-element-index props))
                               (nth elements (:initial-visible-element-index props) nil)
                               :else
                               (first elements))]
                 (let [on-visible (:on-visible (get @variables scroll-id))
                       on-cross-threshold (:on-cross-threshold (get @variables scroll-id))
                       scroll-direction (:scroll-direction props)
                       x-scroll-position (if (= scroll-direction :horizontal)
                                           (+ (:left-position element) (* (:width element) 0.1))
                                           0)
                       y-scroll-position (if (= scroll-direction :horizontal)
                                           0
                                           (+ (:top-position element) (* (:height element) 0.1)))]
                   (if (fn? on-visible)
                     (on-visible {:element element
                                  :scroll-container-id scroll-id
                                  :x x-scroll-position
                                  :y y-scroll-position
                                  :data (:data (get @variables scroll-id))})
                     (if (= (:index element) 0)
                       (do
                         (swap! variables
                           #(-> (assoc-in % [scroll-id :threshold-index] 0)
                              (assoc-in [scroll-id :scroll-threshold-position] (if (= scroll-direction :horizontal)
                                                                                 (* (:width element) 0.5)
                                                                                 (* (:height element) 0.5)))))
                         (when (fn? on-cross-threshold)
                           (on-cross-threshold {:current-element element
                                                :second-adjacent-element (second elements)
                                                :data (:data (get @variables scroll-id))
                                                :scroll-threshold-position (if (= scroll-direction :horizontal)
                                                                             (* (:width element) 0.5)
                                                                             (* (:height element) 0.5))}))
                         (if (= scroll-direction :horizontal)
                           (set! (.-scrollLeft (js/document.getElementById scroll-id)) 0)
                           (set! (.-scrollTop (js/document.getElementById scroll-id)) 0)))
                       (.scrollTo (js/document.getElementById scroll-id) x-scroll-position y-scroll-position)))
                   (swap! variables assoc-in [scroll-id :initial-element-scrolled-to?] true))))
             (swap! variables assoc-in [scroll-id :initial-element-scrolled-to?] false))))
       :display-name
       (str "scroll-container-" scroll-id)
       :reagent-render
       (fn [props]
         (into
           [:div
            (merge
              (dissoc props
                :threshold :on-cross-threshold :on-scrolling :scroll-direction :data :only-check-component-count?
                :is-visible? :on-visible :initial-visible-element-index :initial-visible-element-id)
              {:style (merge
                        (if (= (:scroll-direction props) :horizontal)
                          {:display "flex"
                           :overflow-y "hidden"
                           :overflow-x "auto"
                           :scroll-snap-type "x mandatory"}
                          {:overflow-y "auto"
                           :overflow-x "hidden"
                           :scroll-snap-type "y mandatory"})
                        (:style props))})]
           (r/children (r/current-component))))})))
